<template>
  <div class="menu w1200" :style="company&&(company.memberSystemId==116||company.memberSystemId==89)?'padding: 10px 0':''">
    <div class="w1200 m-auto flex">
      <div v-if="global.isNull(user)" class="loginmenu" @click="loginWindowShow=true">
        <van-icon name="manager"/>
        <span>用户登陆</span>
      </div>
      <div v-if="!global.isNull(user)" class="loginmenu">
        <van-icon name="manager"/>
        <span>{{ user.tel }}</span>
        <small style="margin-left:20px;color:#FF9900;">{{ global.formatDate(user.endDate, 'yyyy-MM-dd') }}到期</small>
        <span class="m-l-20" @click="logout" v-if="company.memberSystemId!=116">退出</span>
      </div>
      <div style="width:250px;padding-top:10px">
        <van-button size="small" color="#45a4b6" to="/pc/choose/0" v-if="returnButtonShow" type="info">返回首頁</van-button>
      </div>
      <div style="clear:both"></div>
    </div>
    <ul :class="company.memberSystemId==116||company.memberSystemId==89?'OneLine':'TwoLine'">
      <li>
        <router-link v-if="company.type!=1" to="/pc/">首页
        </router-link>
      </li>
      <li class="f-w-b blink" v-if="isTaiwan">
        <a href="https://goodgood888.com" target="_blank" :style="fontStyle">汽車材料中心</a>
      </li>
      <li class="f-w-b" v-if="isTaiwan">
        <router-link to="/pc/choose/0" :style="fontStyle">维修资料</router-link>
      </li>
      <li class="f-w-b">
        <router-link to="/pc/choose/1" :style="fontStyle">正时保养</router-link>
      </li>
<!--      <li class="f-w-b" v-if="company.type!=1 && company.memberSystemId != 116">-->
<!--        <router-link to="/pc/choose/2" style="color:#00139e">免费查阅</router-link>-->
<!--      </li>-->
      <li
          v-if="company.type!=1&&(global.isNull(company)||company.isCanPay != 0) ||  company.memberSystemId == 116">
        <router-link to="/pc/product">订购及续费</router-link>
      </li>
      <li v-if="!global.isNull(company)&&company.type!=1">
        <router-link to="/pc/contactus">联系客服</router-link>
      </li>
    </ul>

    <van-popup closeable close-icon="close" @close="loginWindowShow=false" v-model="loginWindowShow"
               style="overflow:hidden;">
      <div class="login loginform">
        <div class="title">用户登陆</div>
        <!-- <form class="layui-form" action="">
          <div class="layui-form-item">
            <label class="layui-form-label">用户名</label>
            <div class="layui-input-inline">
              <input type="text" name="title" required lay-verify="required" placeholder="请输入用户名" autocomplete="off" class="layui-input">
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">密码</label>
            <div class="layui-input-inline">
              <input type="password" name="password" required lay-verify="required" placeholder="请输入密码" autocomplete="off" class="layui-input">
            </div>
          </div>
          <div class="layui-form-item">
            <label class="layui-form-label">验证码</label>
            <div class="flex">
              <input type="password" name="password" required lay-verify="required" autocomplete="off" class="layui-input code">
              <button type="button" class="layui-btn layui-btn-sm">立即登陆</button>
            </div>
            <div class="layui-form-mid layui-word-aux"></div>
          </div>
          <div class="layui-form-item">
            <button type="button" class="layui-btn layui-btn-fluid">立即登陆</button>
          </div>
          <div class="forgetpassword">
            忘记密码
          </div>
        </form>
        <div class="tips">*用户注册请至手机版操作</div>
      </div> -->
        <van-form @submit="onSubmit">
          <van-cell-group :border="false" class="b-g-c-n formcontent">
            <van-field class="b-g-c-n cell iconfont" icon-prefix="icon" left-icon="shouji" maxlength="30"
                       v-model="formData.tel" type="tel" placeholder="用户名称/手机号码/机器码"/>
            <!-- :rules="[{ pattern:formData.verifyPatterns.tel, message: '请正确输入(不需要地区码)' }]" -->
            <van-field v-if="!formData.forgetPassword" class="b-g-c-n cell iconfont" icon-prefix="icon"
                       left-icon="mimayanzhengma" v-model="formData.password1" type="password"
                       :rules="[{ required: true, message: '请填写密码' }]" placeholder="密码"/>
            <van-field v-if="formData.forgetPassword" icon-prefix="icon" left-icon="yanzhengma" v-model="formData.code"
                       type="number" placeholder="验证码" maxlength=6 :rules="[{ required: true, message: '请输入验证码' }]"
                       class="b-g-c-n cell iconfont">
              <template #button>
                <van-button color="#52b1fc" v-show="!verifyData.isSending" size="small" type="info" @click="sendCode"
                            native-type="button">发送验证码
                </van-button>
                <van-button color="#52b1fc" v-show="verifyData.isSending" size="small" type="info" disabled>
                  <van-count-down ref="countDown" style="display: inline-block; color:#fff;" :time="verifyData.time"
                                  @finish="finish" format="ss秒后重发"/>
                </van-button>
              </template>
            </van-field>
            <div class="ta-c p-t-20">
              <van-button class="loginbutton" block round type="info" native-type="submit">登陆</van-button>
            </div>
            <div class="tip ta-l">
              登陆即表示同意
              <span @click="show=true">《服务协议》</span>
              <!-- <van-checkbox style="color:#fff" v-model="formData.checked" icon-size="24px">
                  </van-checkbox>-->
            </div>
            <div class="forgetpassword" @click="findPassword">
              <div>找回密码</div>
            </div>
            <van-popup v-model="show" get-container="body" closeable :style="{width:'80%', height: '70%' }">
              <div class="agreement">
                <article>
                  <h3>服务协议</h3>
                  <p>
                    欢迎使用汽修资料查询系统（以下简称
                    <b>查询系统</b>），在您使用查询系统提供的各项VIP会员及非会员服务（以下简称“
                    <b>服务</b>”，具体形式包括但不限于您获取并使用的数据查询、信息发布、数据接口调用等服务，亦包括未来增加或完善现有服务的任何新功能）之前，请务必仔细阅读并透彻理解本协议。您在使用查询系统服务前，应当仔细认真阅读本《服务协议》(以下简称“
                    <b>本协议</b>”)中的全部条款、规则及内容，确认对本协议全部条款、规则及内容均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用查询系统账号访问查询系统或以其他方式使用或接受服务，即视为您已阅读并与查询系统达成协议，自愿接受本协议全部条款、规则及内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。
                  </p>
                  <section>
                    <div>一、用户注册及服务使用</div>
                    <ul>
                      <li>
                        1.“查询系统账号”是指您通过查询系统网页端或移动智能设备应用端注册的账号。部分服务，需要您在登录您的账号之后方可使用。您在注册时所填写的内容与个人资料必须真实、准确、有效，否则查询系统有权拒绝您的注册申请。在完成账号注册手续后，您将有权通过该账号使用本服务。
                      </li>
                      <li>2.您应妥善保管账户及密码信息，由于您自身原因导致的账户或密码的泄露、遗忘等情形或其他原因所带来的损失，查询系统将配合采取必要措施以降低相关损失，但因此造成的不利后果，需由您自行承担。
                      </li>
                      <li>3.您不得以营利为目的，将您在使用查询系统服务时获得的服务信息或数据向第三方出售或以其他形式提供。否则，查询系统有权停止向您提供服务，且您应支付相当于您因前述转售行为所获利益的违约金。
                      </li>
                      <li>4. 本查询系统只为协助汽修师傅解决汽修技术难题，若是非汽修师傅使用可能会被封号处理，费用不予退还。</li>
                      <li>
                        5.您在使用查询系统服务时，所发布的信息（包括用户名称、用户头像、帮手问答等）及用户行为必须遵守国家有关法律规定以及服务规则，并承担一切因自己发布信息或其他行为导致的民事、行政、或刑事法律责任或其他不利后果。
                      </li>
                      <li>
                        6.如果您在使用查询系统服务时，未能遵守本协议或其他服务规则的规定，为了维护良好服务环境，保障其他用户的合法权益，查询系统有权删除您发布的相关信息，暂时或永久禁止您在查询系统发布信息，直至封停您的账号。
                      </li>
                      <li>
                        7.依照监管要求，对于查询系统在向您提供服务时向您提供的或您在使用查询系统服务时获取的数据及服务信息等，您应当仅在中华人民共和国大陆范围内储存及/或使用，同时您不得利用查询系统提供的数据及服务信息从事任何违反法律、法规或其他监管政策的行为。否则，由此产生的一切不利法律后果由您自行承担。
                      </li>
                    </ul>
                  </section>
                  <section>
                    <div>二、VIP会员服务及案例查询积分条款</div>
                    <ul>
                      <li>
                        当您通过查询系统途径成为VIP会员（以下简称“
                        <b>VIP会员</b>”）时以及本系统所换取积分后您在使用VIP会员服务的同时，须一并遵守本条的以下规定。
                      </li>
                      <li>
                        (一)成为VIP会员的方式
                        <p>
                          1.在成为VIP会员之前，您应先根据真实、准确信息注册成为查询系统用户。当您的个人资料发生变化，应及时修改，否则由此造成的VIP会员权利不能全面有效行使的责任，由您自身承担，查询系统有权因此取消您VIP会员资格，无须退还VIP会员费或给予其他任何形式的赔偿或补偿。
                        </p>
                        <p>2.VIP会员的服务价格以查询系统网站上标注的详细资费标价为准，查询系统对会员的服务有修改价格、升级服务、增减服务内容等权利。</p>
                      </li>
                      <li>
                        （二）积分及VIP会员服务的使用
                        <p>
                          1.您应自行妥善保管、使用、维护您在查询系统申请取得的账号、账号信息及密码，并采取必要和有效的保密措施，避免与第三人共享账号及相关服务信息。非查询系统原因致使您账户密码泄漏以及因您保管、使用、维护不当造成损失的，查询系统无须承担与此有关的任何责任。
                        </p>
                        <p>2.VIP会员服务具有固定的使用期限，您一旦成为VIP会员，即视为同意该服务使用期限的相关规定。</p>
                        <p>3.成为VIP会员后，您有权停止或放弃接受查询系统服务，并有权注销查询系统用户账户，但查询系统无须向您退还已支付的任何费用。</p>
                        <p>4.积分只可以使用在案例查询上无法使用在购买VIP汽修资料会员，充值换取积分后无法返还及退款，积分必须在换取日开始计算一年内使用完毕，过期就算自动放弃权力而无法再使用。</p>
                      </li>
                      <li>
                        （三）积分及VIP会员使用规范
                        <p>
                          1.您知悉并同意：VIP会员账号同一时间同一账号仅可在1台移动通信设备上登录使用，超出上述范围使用的，将被强制下线。用户应当自行承担超范围使用而导致的任何损失，同时查询系统保留追究上述行为人法律责任的权利。
                        </p>
                        <p>
                          2.下述情况查询系统会暂停或终止为您提供服务，并无须退还任何费用。违规使用情形包括：
                          <span>(1) 未经查询系统事先明示同意，转让、借用、出租、赠与或以其他方式，为他人使用您的VIP会员账号提供条件；</span>
                          <span>(2) 未经查询系统事先明示同意，通过爬虫工具、机器人软件等手段获取VIP会员服务或有关数据信息；</span>
                          <span>(3) 通过系统漏洞、黑色产业、滥用会员身份等不正当手段，侵犯查询系统或他人合法权益；</span>
                          <span>(4) 其他违反法律、法规或相关监管政策的行为或违反本协议及其他服务规则的行为。</span>
                        </p>
                        <p>
                          3. 本查询系统为单店使用版本没有绑定设备任何手机及电脑或IPAD都可以查询，VIP会员查询每日会有读取台次限制（
                          <b>单店使用一天查阅数量基本可以满足</b>）若无法接受被限制，请勿加入VIP会员。
                        </p>
                        <p> 4.积分无法转让其他帐号使用 </p>
                      </li>
                      <li>
                        （四）我们会基于如下标准判断您的账号是否存在前述违规使用情形：
                        <p>
                          <span>(1) 同一账号近期登录使用设备数量是否异常；</span>
                          <span>(2) 同一账号单日查询次数是否异常；</span>
                          <span>(3) 是否存在其他足以被认定为违规使用的具体行为。</span>
                        </p>
                        <p>如您发现您的账号遭到未经授权的使用时，请您立即通知查询系统，我们将协助您找回。</p>
                      </li>
                    </ul>
                  </section>
                  <section>
                    <div>三、您在查询系统所发布或展示的信息，不得含有以下内容或用于以下目的：</div>
                    <ul>
                      <li>（1）违反宪法确定的基本原则的；</li>
                      <li>（2）危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的；</li>
                      <li>（3）煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                      <li>（4）破坏国家、地区间友好关系的；</li>
                      <li>（5）违背中华民族传统美德、社会公德、伦理道德、以及社会主义精神文明的；</li>
                      <li>（6）破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                      <li>（7）散布谣言或不实消息，扰乱社会秩序，破坏社会稳定的；</li>
                      <li>（8）煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的；</li>
                      <li>（9）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
                      <li>（10）侮辱或诽谤他人，侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；</li>
                      <li>（11）以非法组织名义活动的；</li>
                      <li>（12）侵犯他人知识产权、商业秘密等合法权益的；</li>
                      <li>（13）含有违反法律、法规、国家政策及公序良俗的法律、行政法规禁止的其他内容的。</li>
                    </ul>
                  </section>
                </article>
              </div>
            </van-popup>
          </van-cell-group>
          <!-- <div v-if="isWxBrowser()" class="wxloginbutton" @click="wxLogin">
              <van-icon style="background:#fff; border-radius:20px" size="40px" color="#00d50b" class="iconfont" class-prefix="icon" name="weixin" />
              <div>微信登陆</div>
            </div> -->

        </van-form>
        <div class="tips" style="color:white">*用户注册请至手机版操作</div>
        <div class="tips" style="margin-top:20px;color:white">请先使用手机搜索小程序【汽修能手】，注册后，再到电脑或仪器中打开浏览器，输入网址carziliao.com，登录查询</div>
      </div>
    </van-popup>
  </div>
</template>

<style>
@import "/plugin/layui/css/layui.css";
@import "../assets/css/css.css";
</style>

<script>
import {
  Icon,
  Popup,
  Dialog,
  Tab,
  Tabs,
  Field,
  Cell,
  CellGroup,
  Button,
  Checkbox,
  CheckboxGroup,
  Form,
  Toast,
  CountDown,
} from "vant";
import {
  LOGIN,
  Send_SMS_Code,
  REG,
  Check_Tel,
  Wx_LOGIN,
  Check_Wx_Login,
} from "@/api/index";

export default {
  name: "PCMenu",
  inject: ["reload"],
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Form.name]: Form,
    [Toast.name]: Toast,
    [CountDown.name]: CountDown,
  },
  props: ['fontSize'],
  computed: {
    company() {
      return this.memberSystem || {};
    },
    isTaiwan(){
      return this.memberSystem&&this.memberSystem.type==1;
    }

  },
  data() {
    return {
      memberSystem: {},
      loginWindowShow:
          this.global.isNull(this.global.getUserInfo()) &&
          !this.global.isNull(this.$route.query.login),
      activeName: "login",
      show: false,
      returnButtonShow: false,
      pattern: /\d{11}/,
      formData: {
        forgetPassword: false,
        tel: "",
        password1: "",
        password2: "",
        code: "",
        verifyTel: {
          isVerify: false,
          result: false,
        },
        verifyPatterns: {
          tel: /(^1\d{10}$)|(^6\d{8}$)|(^0[19]{1}[\d]{8}$)|(^[5|6|8|9]{1}\d{7}$)/,
          password: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,15}$/,
        },
      },
      verifyData: {
        time: 60 * 1000,
        isSending: false,
      },
      user: this.global.getUserInfo(),
      fontStyle: {
        color: '#00139e',
        fontSize: '16px'
      }
      //memberSystem: {},
    };
  },
  methods: {
    asyncValidator() {
      if (this.formData.verifyTel.isVerify) {
        return this.formData.verifyTel.result;
      }
      return Check_Tel({tel: this.formData.tel}).then((data) => {
        this.formData.verifyTel.isVerify = true;
        this.formData.verifyTel.result = data;
        return data;
      });
    },
    async logout() {
      localStorage.clear();

      // sessionStorage.clear();
      let memberSystem = await this.global.getMemberSystem();
      // this.$router.push({ path: "/pc/?memberSystemId=" + memberSystem.memberSystemId });
      this.reload();
    },
    finish() {
      this.verifyData.isSending = false;
    },
    async sendCode() {
      let smsType = 0;
      if (this.formData.tel == "") {
        Toast("请输入电话");
        return false;
      }
      if (this.formData.tel.indexOf("170") == 0) {
        Toast("此号段禁止使用");
        return false;
      }

      if (this.activeName == "reg") {
        smsType = 1;
      }
      this.verifyData.isSending = true;
      // this.verifyData.time = 60 * 1000;
      this.$refs.countDown.reset();
      Send_SMS_Code({
        tel: this.formData.tel,
        type: smsType,
      }).catch(()=>{
        this.verifyData.isSending = false;
      });
    },
    findPassword() {
      Dialog.alert({
        message: "请先使用验证码登陆后，到用户中心重置密码！",
      }).then(() => {
        this.formData.forgetPassword = true;
      });
    },
    async onSubmit() {
      if (this.formData.tel == "") {
        Toast("请输入电话");
        return;
      }
      if (this.formData.tel.indexOf("170") == 0) {
        Toast("此号段禁止使用");
        return false;
      }
      let memberSystem = await this.global.getMemberSystem();
      var params = {
        tel: this.formData.tel,
        memberSystemCode: memberSystem.code,
        code: this.formData.code,
        password: this.formData.password1,
      };
      let response = {};
      if (this.activeName == "login") {
        if (!this.formData.forgetPassword && this.formData.password1 == "") {
          Toast("请输入密码");
          return;
        }
        if (this.formData.forgetPassword && this.formData.code == "") {
          Toast("请输入验证码");
          return;
        }
        response = LOGIN(params);
      } else if (this.activeName == "reg") {
        if (this.formData.code == "") {
          Toast("请输入验证码");
          return;
        }
        if (this.formData.password1 == "") {
          Toast("请输入密码");
          return;
        }
        if (this.formData.password2 == "") {
          Toast("请输入确认密码");
          return;
        }
        if (this.formData.password1 != this.formData.password2) {
          Toast("两次输入的密码不一致");
          return;
        }
        response = REG(params);
      }
      response.then((user) => {
        this.loginProgress(user);
      });
    },
    async loginProgress(user) {
      if (!this.global.isNull(user)) {
        user.memberSystemId=user.systemId
        debugger
        localStorage.setItem("User", JSON.stringify(user));
        localStorage.setItem("AccessToken", user.accessToken);
        localStorage.setItem("RefreshToken", user.refreshToken);
        await this.global.setMemberSystem(user.memberSystemId);
        this.reload();

      }
    },
  },
  async mounted() {
    let company = await this.global.getMemberSystem();
    this.memberSystem = company
    if (company.memberSystemId === 116) {
      this.fontStyle.fontSize = "16px"
      this.fontStyle.color = "#333"
      this.fontStyle.fontWeight = 400;
    }
    console.log(company);
    this.returnButtonShow =
        this.$route.path.indexOf("fileshow") > 0 && company.type == 1;
  },
};
</script>
<style scoped>
.menu ul.OneLine {
  margin-top: -36px;
  justify-content: flex-end;
  margin-right: 50px;
}

.menu ul.OneLine li {
  /*flex:1;*/
  margin: 0 30px 10px 30px;
}

.menu ul.TwoLine li {
  /*flex:1;*/
  margin: 0 40px 10px 40px;
}
.OneLine .router-link-exact-active{
  color:#FF9900!important;
}

/** 闪烁动画定义 *!*/
@keyframes blink {
  /*0%, 100% { opacity: 1; } !* 完全显示 *!*/
  /*50% { opacity: 0.3; }      !* 完全隐藏 *!*/
  0% { opacity: 1; color: red!important; }
  50% { opacity: 0; color: blue!important;; }
  100% { opacity: 1; color: red!important;; }
}

/* 给需要闪烁的元素加这个类 */
.blink {
  animation: blink 1s infinite; /* 1秒闪烁一次，无限循环 */
  /* 可调整：0.5s=快，2s=慢 */
}
</style>
